var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ToastMe'),_c('CElementCover',{directives:[{name:"show",rawName:"v-show",value:(!_vm.is_current_fetched),expression:"!is_current_fetched"}],staticStyle:{"z-index":"100"},attrs:{"opacity":0.8}}),(_vm.checkSetup())?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }